import { AppState, AuthorPageAppState } from '../../initialStateRegistration';
import { AuthorPageSectionNames } from './authorPage.reducer';

export const getAuthorPage = (state: AppState) => (state as AuthorPageAppState).template;

export const getFeed = (state: AppState) => getAuthorPage(state).feed;

export const getImage = (state: AppState) => getAuthorPage(state).image;

export const getName = (state: AppState) => getAuthorPage(state).name;

export const getSocial = (state: AppState) => getAuthorPage(state).social;

export const getDescription = (state: AppState) => getAuthorPage(state).description;

export const getJoinDateText = (state: AppState) => getAuthorPage(state).joinDateText;

export const getJoinDate = (state: AppState) => getAuthorPage(state).joinDate;

export const getArticlesNumberText = (state: AppState) => getAuthorPage(state).articlesNumberText;

export const getTotalArticles = (state: AppState) => getAuthorPage(state).totalArticles;

export const getArticles = (state: AppState) => getAuthorPage(state).articles;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getLoadMoreNext = (key: AuthorPageSectionNames) => (state: AppState) => getFeed(state).next;

export const getLoadMoreText = (state: AppState) => getFeed(state).text;
